import { render, staticRenderFns } from "./setBanner.vue?vue&type=template&id=5fb2a566&scoped=true"
import script from "./setBanner.vue?vue&type=script&lang=js"
export * from "./setBanner.vue?vue&type=script&lang=js"
import style0 from "./setBanner.vue?vue&type=style&index=0&id=5fb2a566&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb2a566",
  null
  
)

export default component.exports